export default __webpack_public_path__ + "static/media/es.e26a0ad9.svg";